import { __assign } from "tslib";
import * as React from 'react';
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3';
export var OverrideExecuteRecaptchaContextForTests = React.createContext({ executeRecaptcha: null });
export var GoogleRecaptchaV3ValidatorInner = function (props) {
    // In tests, we can use `OverrideExecuteRecaptchaContextForTests` to override the execute function
    // since google's script is not available in tests
    var overriddenExecuteRecaptchaInTests = React.useContext(OverrideExecuteRecaptchaContextForTests).executeRecaptcha;
    // In production, google exposes a function to issue a re-captcha verification
    // this function will return a token, which we can then send to our server
    // our server can then check the authenticity of the current user, by sending this token to google
    var realExecuteRecaptchaFunction = useGoogleReCaptcha().executeRecaptcha;
    var executeRecaptcha = overriddenExecuteRecaptchaInTests || realExecuteRecaptchaFunction;
    React.useEffect(function () {
        props.registerExecuteRecaptcha(executeRecaptcha);
    }, [executeRecaptcha]);
    return null;
};
export var GLOBAL_HIDE_CAPTCHA_BADGE_CLASSNAME = 'contact-form-hide-captcha-v3-badge';
// This component manages the embedding of google's re-captcha v3 script
export var GoogleRecaptchaV3Validator = function (props) {
    // Recaptcha V3 no longer renders the badge inside the parent component, it is rendered on the `body` instead
    // in order to hide it, we add a special classname + a rule inside `_submit-ticket.scss` that hides it
    React.useEffect(function () {
        document.body.classList.add(GLOBAL_HIDE_CAPTCHA_BADGE_CLASSNAME);
        return function () {
            document.body.classList.remove(GLOBAL_HIDE_CAPTCHA_BADGE_CLASSNAME);
        };
    }, []);
    return (
    // The provider takes our re-captcha account key and embeds the actual script inside the page header
    // It populates a context with the correct `executeCaptcha` function
    React.createElement(GoogleReCaptchaProvider, { reCaptchaKey: props.recaptchaKey || '' },
        React.createElement(GoogleRecaptchaV3ValidatorInner, __assign({}, props))));
};
//# sourceMappingURL=google-recaptcha-v3.comp.js.map